module.exports = __webpack_public_path__ + "static/media/MyTourAvailability.cc386e8b.svg";